import { render } from "./MovCaja.vue?vue&type=template&id=2a20a720&scoped=true"
import script from "./MovCaja.vue?vue&type=script&lang=js"
export * from "./MovCaja.vue?vue&type=script&lang=js"

import "./MovCaja.vue?vue&type=style&index=0&id=2a20a720&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a20a720"]])

export default __exports__